import { Box } from "reflexbox";

export const Separator = (props) => <Box sx={{ borderBottom: "1px solid", borderColor: "blue.pale" }} {...props} />;
